import config from 'config';
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  InputAdornment,
  Link,
  Modal,
  Popover,
  TextField,
  Tooltip,
} from '@material-ui/core';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from '@mui/icons-material/Close';
import { useRef, useState } from 'react';
import axios from 'axios';
import { showSnackbar } from 'components/root-snackbar';
import { useAppDispatch, useAppSelector } from 'app';
import { store } from 'app';
import React from 'react';
import { GetAttachments } from 'dmsAppsCallbacks';
import { fetchCustomers } from '../Customers/customersSlice';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomerTagTitle } from 'components/setting/models/customer-tag-title';
import CustomerTagPopover from '../Customers/CustomerTagPopover';
import Typography from '@mui/material/Typography';
import Button from '@material-ui/core/Button';
import { parse } from 'json2csv';

function CustomerFileUpload() {
  const [importFile, setImportFile] = useState() as any;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showPopOver, SetSowPopOver] = useState(false) as any;
  const [tag, setTag] = useState({}) as any;
  const [responseError, SetResponseError] = useState('') as any;
  const [sendingData, setSendingData] = useState(false) as any;
  const [customerTags, setCustomerTags] = useState<CustomerTagTitle[]>([]);
  const [popoverChipState, setPopoverChipState] = useState<any>({ openedPopoverId: null, anchorEl: null });
  const [showUploadResults, setShowUploadResults] = useState<boolean>(false);
  const inputRef = useRef(null) as any;
  const dispatch = useAppDispatch();
  const dmsTypeId = useAppSelector((state) => state.user.dmsTypeId);

  const [downloadLink, setDownloadLink] = useState<any>(null);
  const [customersCreatedCount, setCustomersCreatedCount] = useState<number>(0);
  const [customersFailedCount, setCustomersFailedCount] = useState<number>(0);
  const [customersExisting, setCustomersExisting] = useState<number>(0);

  function isFileCsv(el: any) {
    let regex = new RegExp('(.*?).(csv)$');
    if (!regex.test(el.target.files[0].name.toLowerCase())) {
      dispatch(showSnackbar({ type: 'error', message: 'File type must be .csv' }));
      return;
    } else {
      setImportFile(el.target.files[0]);
    }
  }

  function handleFileSelected(event: any) {
    isFileCsv(event);
  }

  function ShowPopOver(event: any) {
    setAnchorEl(event.currentTarget);
    SetSowPopOver(true);
  }

    
  function submitImport(event: any) {
    setCustomersCreatedCount(0);
    setCustomersExisting(0);
    setCustomersFailedCount(0);
    SetResponseError('');
    if (importFile == undefined || importFile == null) {
      dispatch(showSnackbar({ type: 'error', message: 'Please select a .csv file to upload' }));
      return;
    }
    setShowUploadResults(true);
    setSendingData(true);
    let customerUrl = config.get('api.customer');
    let env = config.get('env');
    let url = `${customerUrl}/CustomerFileUpload/${store.getState().user.dealerId}/${
      store.getState().user.isUserAdmin
    }`;
    url = url.replace('v2/', '');
    let formData = new FormData();
    formData.append('file', importFile);
    formData.append('tag', tag.tag);
    axios
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        const respObj = res.data[0];
        setCustomersCreatedCount(res.data[0].CustomersCreated);
        setCustomersExisting(res.data[0].CustomersUpdated);
        setCustomersFailedCount(res.data[0].Failed);
        const csv = parse(res.data[0].AllCustomers); // Convert JSON to CSV
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'data.csv'; // Set the filename
        setDownloadLink(link);
        // Hidding the data review related info for the file upload
        // const respMsg = `Customer created: ${respObj.CustomersCreated}, existed: ${respObj.CustomersUpdated}, moved To review hub: ${respObj.CustomersMovedToReviewhub}`;
        // dispatch(showSnackbar({ type: 'success', message: respMsg }));
        setSendingData(false);
        // inputRef.current.value = null;
        dispatch(fetchCustomers());
        setImportFile(null);
        setShowUploadResults(true);
      })
      .catch((error) => {
        // alert(error);
        // // Error
        setSendingData(false);
        if (error.response) {
          let errorMessage = error.response.data.toString();
          //alert(errorMessage);
          SetResponseError(errorMessage);
          // alert(errorMessage);
          //alert(error.response.data);
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
        } else if (error.request) {
          //alert('k2');
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the
          // browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
          alert(error.request);
        } else {
          //alert('k3');
          alert(error.message);
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        // console.log(error.config);
      });
  }

  const handlePopoverChipOpen = (event: any, popoverId: any) => {
    setPopoverChipState({
      openedPopoverId: popoverId,
      anchorEl: event.currentTarget,
    });
  };

  const handlePopoverChipClose = () => {
    setPopoverChipState({
      openedPopoverId: null,
      anchorEl: null,
    });
  };

  return (
    <span>

{dmsTypeId != 12 && (
      <Tooltip title="Upload customer file">
      <IconButton id="addImportCustomerFromFile" onClick={ShowPopOver}>
        <FileUploadIcon></FileUploadIcon>
      </IconButton>
    </Tooltip>                    
                  )}

      <Modal
        open={showUploadResults}
        // onClose={() => setShowUploadResults(false)}
        aria-labelledby="import-summary-title"
        aria-describedby="import-summary-description">
        <Box
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            padding: '23px',
            transform: 'translate(-50%, -50%)',
            width: 470,
            height: 280,
            backgroundColor: 'white',
            borderRadius: 4,
            //   boxShadow: 3,
            //   p: 3,
            textAlign: 'center',
          }}>
          {sendingData ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <CircularProgress />
            </Box>
          ) : responseError.length > 0 ? (
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100%">
              <Typography variant="h6" fontWeight="bold">
                {responseError == 'Empty File Uploaded' ? responseError : 'Invalid File Format'}
              </Typography>
              <Typography sx={{ mt: 1 }}>
                {responseError == 'Empty File Uploaded'
                  ? 'The uploaded Excel file is empty. Please ensure your file contains valid data and follows the format provided in the sample CSV.'
                  : 'The uploaded file is not in the correct format. Please upload a valid CSV or Excel file and refer to the sample template for guidance.'}
              </Typography>
              <Box mt={3} display="flex">
                <Box style={{ padding: '10px', paddingTop: '5px' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      (window.location.href =
                        'https://stdealer001.blob.core.windows.net/temp/TargetCustomerUploadSample.csv')
                    }>
                    Download Template
                  </Button>
                </Box>
                <Box style={{ padding: '10px', paddingTop: '5px' }}>
                  <Button variant="contained" color="inherit" onClick={() => setShowUploadResults(false)}>
                    Close
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <Typography id="import-summary-title" variant="h6" fontWeight="bold">
                Import Results
              </Typography>
              {/* <Typography id="import-summary-description" sx={{ mt: 1, color: "gray" }}>
              Your import process is complete.
            </Typography> */}
              <Box mt={2} textAlign="left">
                <Typography variant="body1">
                  • <b>New Customers:</b> {customersCreatedCount}
                </Typography>
                <Typography variant="body1">
                  • <b>Existing Customers:</b> {customersExisting}
                </Typography>
                <Typography variant="body1">
                  • <b>Customers Not Imported:</b> {customersFailedCount}
                </Typography>
                <Typography variant="body1">
                  • <b>Total Customers Processed:</b> {customersCreatedCount + customersExisting + customersFailedCount}
                </Typography>
                <Box mt={1}>
                  <Typography variant="caption" color="textSecondary">
                    * Existing customers matched with cell phone or email, so duplicates are not created. Customers with
                    invalid or missing required information are not imported.
                  </Typography>
                </Box>
              </Box>
              <Box mt={2} display="flex" justifyContent="center">
                <Box style={{ padding: '8px' }}>
                  <Button variant="contained" color="inherit" onClick={() => downloadLink.click()}>
                    Download Summary
                  </Button>
                </Box>
                <Box style={{ padding: '8px' }}>
                  <Button variant="contained" color="primary" onClick={() => setShowUploadResults(false)}>
                    Done
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Modal>
      <Popover
        open={showPopOver}
        anchorEl={anchorEl}
        // onClose={() => SetSowPopOver(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <Box style={{ backgroundColor: '#F2F3F4' }}>
          <table style={{ width: '400px' }}>
            <tr>
              <td style={{ paddingLeft: '10px' }}>Customer&nbsp;file&nbsp;upload</td>
              <td style={{ width: '100%', paddingLeft: '20px', fontWeight: 'bold' }}>
                <Link
                  href="#"
                  style={{ fontSize: 'small' }}
                  onClick={() => {
                    window.location.href =
                      'https://stdealer001.blob.core.windows.net/temp/TargetCustomerUploadSample.csv';
                  }}>
                  (Sample&nbsp;CSV&nbsp;File)
                </Link>
              </td>
              <td>
                <IconButton onClick={() => SetSowPopOver(false)}>
                  <CloseIcon fontSize="small"></CloseIcon>
                </IconButton>
              </td>
            </tr>
          </table>
        </Box>
        <Box style={{ padding: '10px' }}>
          <input
            ref={inputRef}
            accept=".csv"
            type="file"
            onClick={(event) => {
              if (
                localStorage.getItem('Login_Source')?.toString() === 'DMS_IDEAL' ||
                localStorage.getItem('Login_Source')?.toString() === 'DMS_INFINITY'
              ) {
                event.preventDefault();
                GetAttachments(26214400, 'csv');
              }
            }}
            onChange={handleFileSelected}
          />
        </Box>
        <Box style={{ padding: '2px 10px' }}>
          <table>
            <tr>
              <td>
                <div style={{ width: '270px' }}>
                  {tag?.tag ? (
                    <Chip
                      label={
                        <div
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '160px',
                          }}>
                          <strong title={tag.title}>{tag.title}</strong> <br /> <span title={tag.tag}>{tag.tag}</span>
                        </div>
                      }
                      style={{ backgroundColor: '#e0e0e0', color: '#424242', height: '45px', padding: '5px' }} // Grey filled Chip
                      onDelete={() => {
                        setTag({});
                      }}
                    />
                  ) : (
                    <TextField
                      variant="outlined"
                      size="medium"
                      margin="dense"
                      type="text"
                      placeholder="Select Tag"
                      onClick={(e) => handlePopoverChipOpen(e, 1)}
                      style={{ width: '220px' }}
                      aria-readonly
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton style={{ marginRight: '-15px' }}>
                              <ArrowDropDownIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </div>
                <Popover
                  id={'pop_' + 1}
                  open={Boolean(popoverChipState.openedPopoverId)}
                  anchorEl={popoverChipState.anchorEl}
                  onClose={handlePopoverChipClose}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}>
                  <Box p={2} style={{ width: '300px' }}>
                    <CustomerTagPopover
                      tag={tag}
                      setTag={setTag}
                      customerTags={customerTags}
                      setCustomerTags={setCustomerTags}
                      setPopoverChipState={setPopoverChipState}></CustomerTagPopover>
                  </Box>
                </Popover>
              </td>
              <td>
                <Button
                  disabled={sendingData}
                  style={{ marginLeft: '30px'}}
                  onClick={(e) => {
                    submitImport(e);
                    SetSowPopOver(false);
                  }}
                  variant="contained">
                  {!sendingData && <span>Upload</span>}
                  {sendingData && <CircularProgress size={24} />}
                </Button>
              </td>
            </tr>
          </table>
        </Box>
        {/* <Box>
         {responseError != '' && (
            <Box style={{ padding: "5px 10px", color: "red" }}>
                <hr></hr>
                Error: {responseError}
            </Box>
          )}
        </Box> */}
      </Popover>
    </span>
  );
}
export default CustomerFileUpload;
